/**
 * Dependent grid mixin
 */
import { mapState } from 'vuex'
import { statusList, statusesAccess } from '@/configs/statuses'
import { listProfileTypes } from '@/configs/profileTypes'

export const gridDependentMixin = {
  statusList,
  statusesAccess,
  listProfileTypes,
  computed: {
    ...mapState('app', ['me']),
    getSettingsViews () {
      return this.me?.preferences?.settings?.views || null
    },
    getViewList () {
      const views = this.getSettingsViews
      if (views) return views.views[this.$options.gridType]
      return []
    },
    getActiveViewKey () {
      const views = this.getSettingsViews
      if (views) return views.usageMap[this.$options.gridType] || 0
      return 0
    },
    getCurrentViewCols () {
      const views = this.getSettingsViews
      if (views) {
        if (!views.views[this.$options.gridType]) return []
        const currentView = views.views[this.$options.gridType].find(existView => {
          return existView.key === views.usageMap[this.$options.gridType]
        })
        if (currentView) return currentView.columns
      }
      return []
    }
  },
  data () {
    return {
      mixSelectedItems: []
    }
  },
  methods: {
    onTableDataChange () {
      this.mixSelectedItems = []
    },
    refetch () {
      this.$refs.tableWrapper.refresh()
    },
    prepareSettingsViews () {
      const meSettings = this.me?.preferences?.settings
      if (meSettings && meSettings.views) {
        return JSON.parse(JSON.stringify(meSettings.views))
      }
      return {
        views: {},
        usageMap: {}
      }
    },
    async updateMeSettings (settings) {
      try {
        await this.$async.updateMe.$perform({
          data: { preferences: { settings } }
        })
        this.$emit('views-updated')
        this.refetch()
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении колонок таблицы')
      }
    },
    async removeStoredView (viewKey) {
      const settingsViews = this.prepareSettingsViews()
      settingsViews.views[this.$options.gridType] = settingsViews.views[
        this.$options.gridType
      ].filter(storedView => {
        return storedView.key !== viewKey
      })
      await this.updateMeSettings({ views: settingsViews })
    },
    async updateStoredActiveView (viewKey) {
      const settingsViews = this.prepareSettingsViews()
      settingsViews.usageMap[this.$options.gridType] = viewKey
      await this.updateMeSettings({ views: settingsViews })
    },
    async updateStoredView (view) {
      const settingsViews = this.prepareSettingsViews()
      const { name, cols, key, isWithActive } = view
      if (!settingsViews.views[this.$options.gridType]) {
        settingsViews.views[this.$options.gridType] = []
      }
      const foundView = settingsViews.views[this.$options.gridType].find(
        storedView => storedView.key === key
      )
      if (foundView) {
        // update view
        foundView.name = name
        foundView.columns = cols
      } else {
        // new view
        settingsViews.views[this.$options.gridType].push({
          name: name,
          columns: cols,
          key: key
        })
      }
      // active view
      if (isWithActive) settingsViews.usageMap[this.$options.gridType] = key
      await this.updateMeSettings({ views: settingsViews })
    },
    getLanguage (item) {
      const laguages = Object.keys(item?.translations).reduce((result, lang) => {
        if (item?.translations[lang]?.isEnabled) {
          result.push(lang)
        }
        return result
      }, [])
      return laguages.join(',')
    },
    async mixCopySlugHandler (item) {
      if (!item && Object.hasOwn(item, 'slug')) {
        this.$errorMsg('Ошибка при копировании уникального имени для URL')
        return
      }
      const { slug } = item
      navigator.clipboard
        .writeText(slug)
        .then(() => this.$successMsg('Уникальное имя для URL скопировано в буфер обмена'))
        .catch(() => this.$errorMsg('Ошибка при копировании уникального имени для URL'))
    },
    mixCutSlug (item, cut = 20) {
      return item.length > 20 ? `${item.slice(0, cut)}...` : item
    },
    mixGetStatus (item) {
      if (!item) return ''
      return statusList?.find((status) => status.value === item?.status)?.text || ''
    },
    mixGetStatusAccess (item) {
      if (!item) return ''
      return statusesAccess?.find((status) => status.value === item?.status)?.text || ''
    }
  },
  created () {
    if (!this.$options.gridType) {
      throw new Error('this.$options.gridType is required for grid component')
    }
  }
}
